Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    gaugeLabelColor: tokens.themeForegroundPrimaryDefault,
    gaugeLabelSize: 20,
    gaugeLabelWeight: 400,
    gaugeLabelLineHeight: "28px",
    gaugeLabelFontFamily: "\"Amazon Ember Display\", \"Amazon Ember\", Arial, sans-serif",
    gaugeLabelSpacingLinearVertical: 8,
    gaugeTrackColor: tokens.themeBorderTertiaryDefault,
    gaugeTrackWidthLinear: 12,
    gaugeTrackWidthCircular: 12,
    gaugeTrackWidthRainbow: 40,
    gaugeNeedleColor: tokens.themeForegroundPrimaryDefault,
    gaugeNeedleBorderColor: tokens.themeBackgroundPrimaryDefault,
    gaugeTargetColor: tokens.themeForegroundPrimaryDefault,
    gaugeTargetWidth: 4,
    gaugeTickMarkColor: tokens.themeBorderSecondaryDefault,
    gaugeTickMarkLength: 3,
    gaugeTickMarkStrokeWidth: 1,
    gaugeTickMarkSpacing: 4,
    gaugeTickMarkLabelFontFamily: "\"Amazon Ember Display\", \"Amazon Ember\", Arial, sans-serif",
    gaugeTickMarkLabelColor: tokens.themeForegroundPrimaryDefault,
    gaugeTickMarkLabelFontSize: 12,
    gaugeTickMarkLabelSpacing: 12,
    gaugeValueColor: "#2C9F93",
    gaugeValueMotionDuration: "200ms",
    gaugeValueMotionFunction: "ease",
    gaugeBorderWidth: 1
  }
};